/**
 * Path helpers
 * These are used to force a specific behavior on a specific page after redirection.
 * These are listed to ensure we keep track of any key-value mapping of special behaviors across the app.
 *
 *
 * To follow:
 *  - which to use query vs state
 *
 *
 * Example:
 *    - immediately open a modal upon redirection
 */
var _a;
// Query - Visible in the URL
var QUERY_NAMES;
(function (QUERY_NAMES) {
    QUERY_NAMES["ACTION"] = "ACTION";
    QUERY_NAMES["SHARED_CALENDAR_ID"] = "SHARED_CALENDAR_ID";
    QUERY_NAMES["UTM_CAMPGAIGN"] = "ITERABLE_CAMPAIGN";
    QUERY_NAMES["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
    QUERY_NAMES["COMPANY_NAME"] = "COMPANY_NAME";
    QUERY_NAMES["REFERRER"] = "REFERRER";
    QUERY_NAMES["TRACE_ID"] = "TRACE_ID";
    QUERY_NAMES["VOUCHER_CODE"] = "VOUCHER_CODE";
})(QUERY_NAMES || (QUERY_NAMES = {}));
export var QUERY_PARAMS = (_a = {},
    _a[QUERY_NAMES.ACTION] = 'action',
    _a[QUERY_NAMES.SHARED_CALENDAR_ID] = 'calId',
    _a[QUERY_NAMES.UTM_CAMPGAIGN] = 'utm_campaign',
    _a[QUERY_NAMES.LOGIN_SUCCESS] = 'loginSuccess',
    _a[QUERY_NAMES.COMPANY_NAME] = 'company_name',
    _a[QUERY_NAMES.REFERRER] = 'referrer',
    _a[QUERY_NAMES.TRACE_ID] = 'trace_id',
    _a[QUERY_NAMES.VOUCHER_CODE] = 'code',
    _a);
export var QUERY_VALUES = {
    BACK_HOME: 'backHome',
    CREATE_BUDGET: 'createBudget',
};
// State - Hidden from URL
export var STATE_KEYS = {
    ACTION: 'action',
    BUDGET_ID: 'budgetId',
    BUDGET_HAS_GROUP: 'budgetHasGroup',
    ENTRY_POINT: 'entryPoint',
    AUTO_FOCUS: 'autoFocus',
    TRACE_ID: 'traceId',
    LOCATION: 'location',
};
export var STATE_VALUES = {
    NOTIFY_MODAL: 'notifyModal',
};
